/**
 * Libellé du pays d'un groupe d'adresse : le pays y est soit l'objet du
 * référentiel (`{ id, value, valueGb }`), soit déjà un libellé.
 */
export function countryLabel(country: any): string {
  return typeof country === 'string' ? country : country?.value;
}

/**
 * Adresse lisible d'un groupe d'adresse, sous la forme
 * « rue, code postal ville, pays » ; les parties absentes sont omises.
 */
export function formatAddress(address: any): string {
  const locality = [address?.zipCode, address?.city].filter(Boolean).join(' ');
  return [address?.street, locality, countryLabel(address?.country)]
    .filter(Boolean)
    .join(', ');
}
